import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-smart-diagnosis-disease',
  templateUrl: './smart-diagnosis-disease.component.html',
  styleUrls: ['./smart-diagnosis-disease.component.scss'],
})
export class SmartDiagnosisDiseaseComponent {}
